import React, {useEffect, useState} from 'react';
import {useInView} from 'react-intersection-observer';
import Lottie from 'react-lottie';
import animationData from '../../public/lotties/EV_HUB_Button_Looping_30Sec_Next_01_V2.json';
import useMediaQuery from '../hooks/useMediaQuery';

export default function LottieButtonNextCTA({
  onClick,
  isDisabled,
}: {
  onClick?: () => void;
  isDisabled?: boolean;
}) {
  const {isMobile} = useMediaQuery();
  const [isVisible, setIsVisible] = useState(false);
  const [buttonRef, inView] = useInView({
    triggerOnce: true,
  });

  useEffect(() => {
    // If the button is in view, set isVisible to true
    if (inView) {
      setIsVisible(true);
    }
  }, [inView]);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
  };

  return (
    <button
      ref={buttonRef}
      onClick={onClick}
      disabled={isDisabled}
      style={{
        border: 'none',
        cursor: 'pointer',
        background: 'none',
        opacity: isVisible ? (isDisabled ? '0.5' : 1) : 0,
        paddingTop: 40,
        transition: 'opacity 750ms ease-in-out',
      }}
    >
      <Lottie
        options={defaultOptions}
        height={isMobile ? 130 : 200}
        width={isMobile ? 130 : 200}
      />
    </button>
  );
}
